module.exports = __webpack_public_path__ + "static/media/madabam02.88e00080.png";